import { DEFAULT_TENANT } from '../tenant/constants'

export const AUTH_COOKIE_NAME = 'com.auravant.auth'

const Cookie = {
  set (name: string, value: string, days = 365) {
    const date = new Date()
    date.setTime(date.getTime() + days * 864e5)
    const expires = '; expires=' + date.toUTCString()
    const path = '; path=/'
    const secure = '; Secure'

    const host = window.location.hostname
    const isTesting = host.includes('testing')
    const isMainTenant = host.endsWith(DEFAULT_TENANT)

    let domain = ''
    if (host.includes('.') && (isMainTenant || isTesting)) {
      domain = `; domain=.${DEFAULT_TENANT}`
    } else {
      domain = `; domain=${host.split('.').slice(1).join('.')}`
    }

    document.cookie = `${name}=${encodeURIComponent(value)}${expires}${path}${secure}${domain}`
  },

  get (name: string): string | undefined {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (let c of ca) {
      c = c.trim()
      if (c.startsWith(nameEQ)) return decodeURIComponent(c.substring(nameEQ.length))
    }
    return undefined
  },

  erase (name: string) {
    const pastDate = new Date(0).toUTCString()
    const path = '; path=/'
    const secure = '; Secure'

    const hostname = window.location.hostname
    const parts = hostname.split('.')
    const domainsToTry = new Set<string>()

    // Sin domain (cookie host-only)
    domainsToTry.add('')

    // Generar todas las combinaciones posibles de dominio
    for (let i = 0; i <= parts.length - 2; i++) {
      const domain = '.' + parts.slice(i).join('.')
      domainsToTry.add(`; domain=${domain}`)
    }

    // Ejecutar un intento de borrado por cada dominio posible
    for (const domain of Array.from(domainsToTry)) {
      document.cookie = `${name}=; expires=${pastDate}${path}${secure}${domain}`
    }
  }
}

export default Cookie
